import {MixedPanel} from '../models/mixed-panel';
import {PanelLoader} from '../models/panel-loader';
import {BackbaseLauncherDeckContainer} from '../models/backbase-launcher-deck-container';

export class BackbasePanelLoadService implements PanelLoader{
    public async loadPanels(ldc: BackbaseLauncherDeckContainer): Promise<Array<MixedPanel>> {
        const mixedPanels: Array<MixedPanel> = [];
        ldc._getPanels().map(bbPanel => {
            mixedPanels.push({
                id: bbPanel.model.name,
                hash: bbPanel.getAttribute('title'),
                widgets: [], // assign an empty array in backbase panel
                show: () => {
                    ldc.showPanel(bbPanel);
                },
                hide: () => {
                    ldc._closeActivePanel();
                },
                defaultPanelToShow: () => {  // assign a dummy function to return false
                    return false; 
                }
            })
        });
        return mixedPanels;
    }
}
